import React, { useState, useEffect } from "react";
import { Row, Col, Input, Label } from "reactstrap";
import { useNavigation } from "react-navi";
import { toast } from "react-toastify";
import categoryService from "../../services/api/categoryService";
import { encodeUrlParams } from "../../services/utils";
import Section from "../components/Section";

function TemplateSearch(props) {
  const [searchParameters, setSearchParameters] = useState(null);
  const [categories, setCategories] = useState([]);
  const { onChange } = props;
  const navigation = useNavigation();

  function handleChange(event) {
    // If property has no value then we remove it
    if (event.target.value === "") {
      const params = searchParameters;
      delete params[event.target.name];
      setSearchParameters({ ...params }); // We must pass a new object instead of the "params" object itself so the effect below triggers
      return;
    }
    setSearchParameters({
      ...searchParameters,
      [event.target.name]: event.target.value
    });
  }

  useEffect(() => {
    onChange(searchParameters);
    navigation.navigate(`/templates?${encodeUrlParams(searchParameters)}`);
  }, [searchParameters]);
  useEffect(() => {
    async function fetchData() {
      const [res, err] = await categoryService.getCategories();
      if (err) {
        toast.error(`Error: ${err.message}`, {
          bodyClassName: "text-danger"
        });
      }
      setCategories(res.data);
    }
    fetchData();
  }, []);

  const categoryOptions = categories.map(cat => (
    <option value={cat._id}>{cat.name}</option>
  ));
  categoryOptions.unshift(
    <option value="" selected>
      Any
    </option>
  );

  return (
    <Section title="Filters" closed>
      <Row className="d-flex justify-content-center">
        <Col xs={12} md={4}>
          <Label for="name">Name</Label>
          <Input
            required
            type="text"
            name="templateName"
            id="templateName"
            onChange={handleChange}
          />
        </Col>
        <Col xs={12} md={4}>
          <Label for="category">Category</Label>
          <Input
            required
            type="select"
            name="category"
            className="dropdown-black"
            id="category"
            onChange={handleChange}
          >
            {categoryOptions}
          </Input>
        </Col>
        <Col xs={12} md={4}>
          <Label for="setting">Mode</Label>
          <Input
            required
            type="select"
            name="setting"
            id="setting"
            className="dropdown-black"
            onChange={handleChange}
          >
            <option value="" selected>
              Any
            </option>
            <option value="1">Plain photo</option>
            <option value="2">GIF</option>
            <option value="3">Boomerang</option>
            <option value="4">Augmented reality</option>
            <option value="5">Green screen</option>
            <option value="6">Mosaic</option>
          </Input>
        </Col>
      </Row>
    </Section>
  );
}

export default TemplateSearch;



// WEBPACK FOOTER //
// ./src/views/template/templateSearch.jsx